"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (initialState, handlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var reduceFn = handlers[action.type];
    return reduceFn ? reduceFn(state, action) : state;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/utils/create-reducer.js
// module id = 575
// module chunks = 0